import { z } from "zod"

export const StorageEntitySchema = z.enum(["project", "task", "message"])

export const StorageFileStatusSchema = z.enum(["pending", "uploaded"])

export const StorageFileResponseSchema = z.object({
  id: z.string(),
  entityId: z.string().optional(),
  entityType: StorageEntitySchema.optional(),
  filename: z.string(),
  key: z.string(),
  contentType: z.string(),
  size: z.number().optional(),
  uploadedBy: z.string(),
  status: StorageFileStatusSchema,
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
})

export type StorageFileResponse = z.infer<typeof StorageFileResponseSchema>

export const StorageFileDownloadUrlResponseSchema = z.object({
  url: z.string().url(),
  filename: z.string(),
  contentType: z.string(),
})

export type StorageFileDownloadUrlResponse = z.infer<typeof StorageFileDownloadUrlResponseSchema>
